module.exports = __webpack_public_path__ + "img/order_nodata.5bfe521e.svg";